export default __webpack_public_path__ + "static/media/landing-image-tunnels.dcd4a563.jpg";